import {CabBreedingFemale} from 'api/gen/CabBreedingFemale';
import {CabCalf} from 'api/gen/CabCalf';

type Animal = Partial<
    Pick<CabCalf & CabBreedingFemale,
    | 'inbreedingBullLineRegistry'
    | 'fatherLineRegistry'
    | 'fatherEarTag'
    | 'inbreedingBullEarTag'
    | 'mothersFatherLineRegistry'
    | 'earTag'
    >
>;

/**
 * Creates a bull-browser link resolver for the selected bull-related field.
 *
 * @param key Row field that contains the bull identifier to open.
 * @returns A callback that resolves the bull browser path for a row.
 */
export const getBullBrowserLink = (key: keyof Animal) => (row: Animal): string => {
    const value = row[key];

    return `/ProhlizecZvirat/Index/${value ?? ''}`;
};
